export default __webpack_public_path__ + "static/media/list.030b4cec.svg";